<template>
    <div v-if="contrato">

        <dados-usuario :usuario="usuario"></dados-usuario>

        <div class="form-group">
            <div class="col-sm-10">
                <button :disabled="!itsOK" type="button" @click="send()" class="btn btn-success">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR USUÁRIO
                </button>
            </div>
        </div>

    </div>
</template>
<script>
/* global swal */
import Vue from "vue";
import { Usuario } from "../../../class/index";
import { DadosUsuario } from "../../../components/exports";
import contratoMixin from "../../mixins/contrato";
export default {
    components: {
        DadosUsuario
    },
    mixins: [contratoMixin],
    data() {
        return {
            usuario: null
        };
    },
    computed: {
        itsOK: function() {
            if (!this.usuario) {
                return false;
            } else if (!this.usuario.nome || !this.usuario.email) {
                return false;
            }
            return true;
        }
    },
    beforeMount() {
        if (this.$route.params.usuario_id) {
            Usuario.byPK(this.$route.params.usuario_id)
                .then(data => (this.usuario = data))
                .catch(err => {
                    if (err.data && err.data.code === 401) {
                        window.location.href = Vue.http.options.root;
                    }
                    this.usuario = Usuario.create();
                    this.ajustarUsuario();
                });
        } else {
            this.usuario = Usuario.create();
            this.ajustarUsuario();
        }
    },
    methods: {
        ajustarUsuario() {
            this.usuario.level = 100;
            this.usuario.contrato_id = this.contrato._id;
        },
        send() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o usuário?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Usuario.save(this.usuario)
                                .then(() => {
                                    this.$router.push(
                                        "/contrato/usuarios/" +
                                            this.contrato._id
                                    );
                                    resolve();
                                })
                                .catch(err => {
                                    if (err.data && err.data.code === 403) {
                                        return swal(
                                            "Email",
                                            "Email já sendo usado",
                                            "error"
                                        );
                                    }
                                    if (err.data && err.data.code === 402) {
                                        return swal(
                                            "Email",
                                            err.data.error,
                                            "error"
                                        );
                                    }
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
